/**
 * Flutter WebView bridge.
 * Flutter registers a JavaScript channel named FlutterBridge.
 * No secrets belong in this file. The token comes from the page query
 * or from window.chatbotApi.setUser().
 */

export function sendToFlutter(type, payload) {
    const message = {
        type: String(type || ''),
        payload: payload === undefined ? null : payload
    };
    const encoded = JSON.stringify(message);

    try {
        if (window.FlutterBridge && typeof window.FlutterBridge.postMessage === 'function') {
            window.FlutterBridge.postMessage(encoded);
            return;
        }
    } catch (err) {
        // Fall through to the parent-frame channel.
    }

    try {
        if (window.parent && window.parent !== window) {
            window.parent.postMessage(message, '*');
        }
    } catch (err) {
        // The host is not listening. The chat UI still works.
    }
}

export function registerChatbotApi(api) {
    window.chatbotApi = {
        setUser(user) {
            if (api && typeof api.setUser === 'function') {
                api.setUser(user || {});
            }
        },
        setTheme(theme) {
            if (api && typeof api.setTheme === 'function') {
                api.setTheme(theme);
            }
        },
        open() {
            if (api && typeof api.open === 'function') {
                api.open();
            }
        },
        close() {
            if (api && typeof api.close === 'function') {
                api.close();
            }
        }
    };
}
